import axios, {AxiosResponse} from 'axios'
import httpClient from './index'
import url from './url'

class OrderDetailsService {
  private static get client() {
    return httpClient.instance
  }

  static getOrderHeaderDetails<T>(): Promise<T> {
    return this.client
      .get(url.getOrderHeaderDetails())
      .then((response: AxiosResponse<T>) => response.data)
      .catch(error => {
        if (axios.isAxiosError(error) && error.response)
          throw new Error(`${error.response.status}`)
        else throw new Error('500')
      })
  }
}

export default OrderDetailsService
